import React from 'react';
import styled from 'styled-components';
import { IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const PageContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  min-height: 56px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
`;

const IframeContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background-color: white;
`;

export const SourcebotPage: React.FC = () => {
  // Use internal Sourcebot URL from config to avoid CSP issues
  const sourcebotUrl = 'http://172.30.124.122:3000';
  
  const handleOpenInNewTab = () => {
    window.open(sourcebotUrl, '_blank');
  };

  return (
    <PageContainer>
      <HeaderContainer>
        <Title>Sourcebot</Title>
        <IconButton
          onClick={handleOpenInNewTab}
          size="small"
          title="Open in new tab"
        >
          <OpenInNewIcon />
        </IconButton>
      </HeaderContainer>
      <IframeContainer>
        <StyledIframe
          src={sourcebotUrl}
          title="Sourcebot"
          allow="microphone; camera; geolocation; payment"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-modals"
        />
      </IframeContainer>
    </PageContainer>
  );
};